import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-saCarrier-lookup',
  templateUrl: './micro-saCarrier-lookup.component.html'
})
export class MicroSaCarrierLookupComponent  {

  @Input()
  saCarrierId:any;

  @Input()
  link:boolean = true;
}
